export const PatchApplicationPreferences = {
    endpoint: "/users/@self/preferences/:application",
    pathParams: ["id"],
    method: "PATCH",
    request: undefined,
    response: undefined,
    paginated: false,
};
//# sourceMappingURL=PatchApplicationPreferences.js.map